var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require('@/resources/images/BigLoader.png'),"width":"170","height":"170"}})
}
var staticRenderFns = []

export { render, staticRenderFns }